module.exports = __webpack_public_path__ + "img/boots-bg.5c63e966.jpg";